import React from 'react'
import CurrencyFormat from 'react-currency-format'

import Stock from './stock'

function Price({ item, loading, iscrosssell }) {

    return (
        (item.variations[0].variation_status == null || item.variations[0].variation_status == '') ? (
            <>
                {(item.variations.length > 1) ? (
                    <>
                        <div className="flex items-center space-x-3 mt-2 mb-4 text-lg">
                            <div className="price-inc-vat"><span className="font-semibold">&nbsp;</span> <span className="text-gray-500 font-medium text-xxs"><small>&nbsp;</small></span></div>
                            <div className="price-exl-vat"><span className="font-semibold">&nbsp;</span> <span className="text-gray-500 font-medium text-xxs"><small>&nbsp;</small></span></div>
                        </div>
                    </>
                ) : (
                    <>
                        <Stock variation={item.variations[0]}></Stock>

                        {(loading) ? ("Loading") : (
                            <div className="price flex items-center space-x-4 mt-2 mb-4 text-lg">
                                {(item.variations[0].price_ex_vat && item.variations[0].price_ex_vat > 0) ? (
                                    <div className="price-exl-vat">
                                        {/* Show cross-sell pricing with original price struck through */}
                                        {iscrosssell && item.variations[0].actual_price_ex_vat && item.variations[0].actual_price_ex_vat !== item.variations[0].price_ex_vat ? (
                                            <div className="flex flex-col">
                                                <span className="font-medium line-through text-gray-400 text-sm">
                                                    <CurrencyFormat decimalScale={2} value={item.variations[0].actual_price_ex_vat / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                                </span>
                                                <span className="font-medium text-red-600">
                                                    <CurrencyFormat decimalScale={2} value={item.variations[0].price_ex_vat / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                                </span>
                                            </div>
                                        ) : (
                                            <span className="font-medium">
                                                <CurrencyFormat decimalScale={2} value={item.variations[0].price_ex_vat / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                            </span>
                                        )}
                                        <span className="block text-gray-500 font-medium text-xxs">(EX. VAT)</span>
                                        {iscrosssell && item.variations[0].actual_price_ex_vat && item.variations[0].actual_price_ex_vat !== item.variations[0].price_ex_vat && (
                                            <span className="block text-green-600 font-medium text-xs">
                                                Save £{((item.variations[0].actual_price_ex_vat - item.variations[0].price_ex_vat) / 100).toFixed(2)}
                                            </span>
                                        )}
                                    </div>
                                ) : ('')}
                                {(item.variations[0].price_inc_vat && item.variations[0].price_inc_vat > 0) ? (
                                    <div className="price-inc-vat">
                                        {/* Show cross-sell pricing with original price struck through */}
                                        {iscrosssell && item.variations[0].actual_price_inc_vat && item.variations[0].actual_price_inc_vat !== item.variations[0].price_inc_vat ? (
                                            <div className="flex flex-col">
                                                <span className="font-bold line-through text-gray-400 text-sm">
                                                    <CurrencyFormat decimalScale={2} value={item.variations[0].actual_price_inc_vat / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                                </span>
                                                <span className="font-bold text-red-600">
                                                    <CurrencyFormat decimalScale={2} value={item.variations[0].price_inc_vat / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                                </span>
                                            </div>
                                        ) : (
                                            <span className="font-bold">
                                                <CurrencyFormat decimalScale={2} value={item.variations[0].price_inc_vat / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                            </span>
                                        )}
                                        <span className="block text-gray-500 font-medium text-xxs">(INC. VAT)</span>
                                        {iscrosssell && item.variations[0].actual_price_inc_vat && item.variations[0].actual_price_inc_vat !== item.variations[0].price_inc_vat && (
                                            <span className="block text-green-600 font-medium text-xs">
                                                Save £{((item.variations[0].actual_price_inc_vat - item.variations[0].price_inc_vat) / 100).toFixed(2)}
                                            </span>
                                        )}
                                    </div>
                                ) : ('')}
                            </div>
                        )}

                    </>
                )}
            </>
            ) : (
                <>
                    <span className="text-gray-500 font-medium text-xs">Advanced Water Code: {item.variations[0].sku}</span>
                    {item.variations[0].variation_status == 'Obsolete' ? (
                        <div className="text-sm text-gray-600 mt-1">This product has been made obsolete and is no longer available. Need a replacement?<br/>Please contact us and we can help you find an alternative.</div>
                    ) : ('')}
                    {item.variations[0].variation_status == 'Superseded' ? (
                        <div className="text-sm text-gray-600 mt-1">This product has been made obsolete, but has been replaced by the part listed below.<br/>Please click the button to navigate to the new product.</div>
                    ) : ('')}
                    {item.variations[0].variation_status == 'Price On Application' ? (
                        <div className="text-sm text-gray-600 mt-1">This product is price on application, please contact us for pricing.</div>
                    ) : ('')}
                </>
            )
    );
}

export default Price;